import { createTheme } from '@mui/material/styles';
import { ThemeOptions } from '@mui/material/styles/createTheme';

export const createAppTheme = (mode: 'light' | 'dark') => {
  const common: ThemeOptions = {
    palette: {
      mode,
      primary: {
        main: '#1976D2',
        light: '#63a4ff',
        dark: '#004ba0',
      },
      secondary: {
        main: '#FF5722',
        light: '#ff8a50',
        dark: '#c41c00',
      },
      error: { main: '#F44336' },
      warning: { main: '#FFA726' },
      info: { main: '#29B6F6' },
      success: { main: '#66BB6A' },
      // background/text customized per mode below
    },
    typography: {
      fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
      h1: { fontFamily: '"Lexend", "Roboto", "Helvetica", "Arial", sans-serif', fontWeight: 500 },
      h2: { fontFamily: '"Lexend", "Roboto", "Helvetica", "Arial", sans-serif', fontWeight: 500 },
      h3: { fontFamily: '"Lexend", "Roboto", "Helvetica", "Arial", sans-serif', fontWeight: 500 },
      h4: { fontFamily: '"Lexend", "Roboto", "Helvetica", "Arial", sans-serif', fontWeight: 500 },
      h5: { fontFamily: '"Lexend", "Roboto", "Helvetica", "Arial", sans-serif', fontWeight: 500 },
      h6: { fontFamily: '"Lexend", "Roboto", "Helvetica", "Arial", sans-serif', fontWeight: 500 },
      button: { textTransform: 'none' },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: { borderRadius: 8, padding: '8px 16px' },
          contained: {
            boxShadow: 'none',
            '&:hover': { boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)' },
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: { borderRadius: 12, boxShadow: '0 2px 12px rgba(0, 0, 0, 0.08)' },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          root: { padding: '12px 16px' },
          head: {
            fontWeight: 600,
            backgroundColor: mode === 'light' ? '#F5F7FA' : 'rgba(255,255,255,0.04)',
          },
        },
      },
    },
  };

  const light: ThemeOptions = {
    palette: {
      background: { default: '#F5F7FA', paper: '#FFFFFF' },
      text: { primary: '#333333', secondary: '#666666' },
    },
  };

  const dark: ThemeOptions = {
    palette: {
      background: { default: '#0F1623', paper: '#121A2A' },
      text: { primary: '#E6EAF2', secondary: '#AAB2C0' },
    },
    components: {
      MuiCard: {
        styleOverrides: {
          root: { boxShadow: '0 2px 12px rgba(0, 0, 0, 0.4)' },
        },
      },
    },
  };

  const options: ThemeOptions = {
    ...common,
    palette: { ...common.palette, ...(mode === 'light' ? light.palette : dark.palette) },
    components: {
      ...common.components,
      ...(mode === 'light' ? light.components : dark.components),
    },
  } as ThemeOptions;

  return createTheme(options);
};

export default createAppTheme('light');